// extracted by mini-css-extract-plugin
module.exports = {"technology__features":"Features_technology__features__60qY3","technology__features_subtitle":"Features_technology__features_subtitle__1SRnK"};